import NewsConfiguration from '../models/NewsConfiguration';
import NewsArticle from '../models/NewsArticle';

export default class NewsMapper {
    public map(data: any) : NewsConfiguration {
        const configuration : NewsConfiguration = new NewsConfiguration();

        configuration.importantUpdateText = data.ImportantUpdateText;
        configuration.continueToSiteText = data.ContinueToSiteText;
        configuration.previousUpdateText = data.PreviousUpdateText;
        configuration.nextUpdateText = data.NextUpdateText;
        configuration.articles = data.Articles.map((category : any) : NewsArticle => { return this.mapArticle(category); });

        return configuration;
    }

    public mapArticle(data: any) : NewsArticle {
        const article : NewsArticle = new NewsArticle();
        article.nodeGUID = data.NodeGUID;
        article.title = data.Title;
        article.publicationDate = data.PublicationDate;
        article.linkText = data.LinkText;
        article.url = data.Url;

        return article;
    }
}